import React, { createContext, useContext, useState, useEffect } from 'react';
import { languages, defaultLang } from './config';
import { translations } from './translations';

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const detectLang = () => {
    try {
      const stored = localStorage.getItem('flautreach-lang');
      if (stored && translations[stored]) return stored;
    } catch (e) {}
    const browser = (navigator.language || navigator.userLanguage || '').toLowerCase();
    const found = languages.find(l => browser.startsWith(l.code));
    return found ? found.code : defaultLang;
  };

  const [lang, setLangState] = useState(detectLang);

  const setLang = (code) => {
    if (translations[code]) {
      setLangState(code);
      try { localStorage.setItem('flautreach-lang', code); } catch (e) {}
      document.documentElement.setAttribute('lang', code);
    }
  };

  useEffect(() => {
    document.documentElement.setAttribute('lang', lang);
  }, [lang]);

  const t = (path) => {
    const keys = path.split('.');
    let val = translations[lang];
    for (const k of keys) {
      if (val === undefined) return path;
      val = val[k];
    }
    return val !== undefined ? val : path;
  };

  return (
    <I18nContext.Provider value={{ lang, setLang, t, languages }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);